// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'e1fae233-3f3c-4097-9910-6a5f3f0673ca',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'de95b697-0aad-4569-8dd9-eb7caec49712',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Item_Blue_Background_Variation',
      parent: 'e1fae233-3f3c-4097-9910-6a5f3f0673ca',
      data: {
        DEBUG: true
      }
    },
    {
      id: 'adbce9e4-7fb1-4612-822b-f2c46ff0a8d1',
      type: 'Sprite',
      name: 'lock',
      className: '',
      x: 84,
      y: -84,
      anchor: {
        x: 0.5,
        y: 0.11
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Gold_Lock',
      parent: 'e1fae233-3f3c-4097-9910-6a5f3f0673ca'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  animations: [
    {
      id: '7c12e156-3971-4c1b-8c99-307580c531ae',
      name: 'disappear',
      playingSpeed: 1,
      totalDuration: 300,
      blocks: [
        {
          id: 'd19c5dd8-1926-49e0-8fe4-494b5a9207cc',
          type: 'Tween',
          name: 'disappearTween',
          duration: 300,
          track: 1,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'lock',
          easing: 'ElasticIn',
          disabled: false
        }
      ]
    },
    {
      id: 'b13a502e-044a-4922-9ff7-c71128408714',
      name: 'Idle_Lock',
      playingSpeed: 1,
      totalDuration: 2000,
      blocks: [
        {
          id: '80edeca1-d86f-4b48-b4aa-91d8c8e9fc80',
          type: 'Tween',
          name: 'New_tween',
          duration: 300,
          track: 2,
          target: {
            angle: 3
          },
          startAt: 0,
          sourceName: 'lock',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '202c4965-e930-4858-90e8-3fd535e18591',
          type: 'Tween',
          name: 'New_tween_copy',
          duration: 300,
          track: 2,
          target: {
            angle: -2
          },
          startAt: 300,
          sourceName: 'lock',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'cda7d124-068f-41f0-9589-0eddf0b03eec',
          type: 'Tween',
          name: 'New_tween_copy_copy',
          duration: 300,
          track: 2,
          target: {
            angle: 0
          },
          startAt: 600,
          sourceName: 'lock',
          easing: 'SinusoidalInOut',
          disabled: false
        }
      ]
    },
    {
      id: 'd7d90ef0-f2f7-4521-b4a3-6be17257cfbe',
      name: 'appear',
      playingSpeed: 1,
      totalDuration: 10,
      blocks: []
    }
  ],
  handleResize: false
} as const;

export class SeasonPassRewardPremiumLockLayout {
  static raw = raw;
  root!: Container;
  lock!: Sprite;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class disappear {
  Layout: {
    lock: object;
  };

  BlockTypeByName: {
    disappearTween: object;
  };

  flowData = raw.animations[0];
}

export abstract class Idle_Lock {
  Layout: {
    lock: object;
  };

  BlockTypeByName: {
    New_tween: object;
    New_tween_copy: object;
    New_tween_copy_copy: object;
  };

  flowData = raw.animations[1];
}

export abstract class appear {
  Layout: {

  };

  BlockTypeByName: {};

  flowData = raw.animations[2];
}
